<template>
  <div class="AddStudentCom">
    <el-button size="small" type="primary" @click="showDialog"
      >添加学生</el-button
    >
    <el-dialog
      :center="true"
      custom-class="el__dialog"
      :visible.sync="flag"
      title="添加学生"
      :lock-scroll="true"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :before-close="studentAddFields"
      width="40%"
    >
      <el-scrollbar style="height: 680px;">
        <p class="dialog__content__title">学生信息：</p>
        <el-form
          :model="student"
          ref="student"
          :rules="studentRules"
          label-width="100px"
        >
          <el-form-item label="姓名" class="el__item" prop="name">
            <el-input
              style="width: 280px"
              v-model.trim="student.name"
              placeholder="学生姓名"
              maxlength="20"
            />
          </el-form-item>
          <el-form-item
            v-if="type == 8 ? false : true"
            label="学籍号"
            class="el__item"
          >
            <el-input
              style="width: 280px"
              v-model.trim="student.rosterNo"
              placeholder="学籍号"
            />
          </el-form-item>
          <el-form-item
            v-else
            label="学员编号"
            prop="rosterNo"
            class="el__item"
          >
            <el-input
              style="width: 280px"
              v-model.trim="student.rosterNo"
              placeholder="学员编号"
              maxlength="20"
            />
          </el-form-item>
          <el-form-item label="身份证号" class="el__item" prop="idCard">
            <el-input
              style="width: 280px"
              v-model.trim="student.idCard"
              @blur="blurIdCard"
              placeholder="身份证号"
            />
          </el-form-item>
          <el-form-item label="年级" class="el__item" prop="gradeId">
            <!-- @change="value => changeclassesList(value)" -->
            <el-select
              :disabled="roleId == '-1003' ? true : false"
              v-model="student.gradeId"
              placeholder="请选择年级"
              style="width: 280px"
              @change="changeclassesList"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.gradeId"
                :label="item.name"
                :value="item.gradeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" class="el__item" prop="classesId">
            <el-select
              :disabled="
                student.gradeId == '' ? true : roleId == '-1003' ? true : false
              "
              v-model="student.classesId"
              style="width: 280px"
              placeholder="请选择班级"
            >
              <el-option
                v-for="item in classesList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" class="el__item" prop="sex">
            <el-select
              v-model="student.sex"
              style="width: 280px"
              placeholder="请选择性别"
            >
              <el-option :value="0" label="男"></el-option>
              <el-option :value="1" label="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="民族" class="el__item" prop="nation">
            <el-select v-model="student.nation" filterable style="width: 280px">
              <el-option
                v-for="item in nationList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生日" class="el__item">
            <el-input
              style="width: 280px"
              v-model="student.birth"
              placeholder="生日"
              disabled
            />

            <!-- <el-date-picker
            v-model="student.birth"
            value-format="yyyy-MM-dd"
            style="width: 280px"
          /> -->
          </el-form-item>
          <el-form-item label="政治面貌" class="el__item" prop="politics">
            <el-select
              v-model="student.political"
              style="width: 280px"
              filterable
            >
              <el-option
                v-for="item in politicsList"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="籍贯" class="el__item" prop="nativePlace">
            <el-input
              v-model.trim="student.nativePlace"
              style="width: 280px"
              placeholder="籍贯"
            />
          </el-form-item>
          <el-form-item label="家庭住址" class="el__item" prop="address">
            <el-input
              v-model.trim="student.address"
              type="textarea"
              style="width: 280px"
            />
          </el-form-item>
        </el-form>

        <!-- 家长信息 -->
        <p class="dialog__content__title">家长信息：</p>
        <!--prop="parent.mobile" required  -->
        <el-form :model="parent" ref="parent" label-width="100px">
          <el-form-item label="家长姓名" class="el__item" prop="name">
            <el-input
              v-model.trim="parent.name"
              style="width: 280px"
              placeholder="家长姓名"
              maxlength="20"
            />
          </el-form-item>
          <!-- required -->
          <el-form-item label="手机号" class="el__item" prop="mobile">
            <el-input
              v-model.trim="parent.mobile"
              style="width: 280px"
              placeholder="手机号"
              maxlength="11"
            />
          </el-form-item>
          <!-- required -->
          <el-form-item label="家长角色" class="el__item" prop="relation">
            <el-select
              clearable
              v-model="parent.relation"
              style="width: 280px"
              filterable
            >
              <el-option
                v-for="item in relationList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <footer class="dialog__footer" slot="footer">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="hidedialogflag">取消</el-button>
          <el-button size="small" type="primary" @click="submit('student')"
            >确定</el-button
          >
        </el-row>
      </footer>
    </el-dialog>
  </div>
</template>
<script>
import { checkParentPhone, saveStudent, dictCode } from '@/api/home'
// import info from "@/mixins/info";

export default {
  name: 'AddStudentCom',
  props: {
    relationList: {
      type: Array
    },
    gradeList: {
      type: Array
    },
    nationList: {
      type: Array
    }
  },
  // mixins: [info],
  data() {
    const checkphone = (rule, value, callback) => {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请填写正确的手机'))
      } else {
        checkParentPhone({ phone: value })
          .then(async () => {
            await callback()
          })
          .catch(error => {
            return callback(new Error(error))
          })
      }
    }
    const checkidCard = (rule, value, callback) => {
      let _id_reg = /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}[\dXx]$/
      if (value && !_id_reg.test(value)) {
        callback(new Error('请填写正确的身份证号'))
      } else {
        callback()
      }
      //   if (!value) {
      //   return callback(new Error('身份证号不能为空'))
      // } else
    }
    return {
      flag: false,
      student: {
        id: '',
        name: '', // 姓名
        rosterNo: '', // 学籍号
        address: '', // 家庭住址
        birth: '', // 生日
        idCard: '', // 身份证号码
        nation: '汉族', // 民族
        nativePlace: '', // 籍贯
        political: '', // 政治面貌
        sex: '', // 性别
        gradeId: '', // 年级
        classesId: '', // 班级
        schoolId: 0
      },
      parent: {
        name: '',
        mobile: '',
        relation: ''
      },

      type: '',
      typeTime: '',
      roleId: localStorage.getItem('roleId'),
      politicsList: [],
      // classesList: [],
      studentRules: {
        name: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: ['blur', 'change']
          }
        ],
        // rosterNo: [
        //   {
        //     required: false,
        //     message: '学籍号不能为空',
        //     trigger: ['blur'],
        //   },
        //   {
        //     min: 6,
        //     message: '学籍号至少6位及以上',
        //     trigger: ['blur'],
        //   },
        // ],
        idCard: [
          {
            required: false,
            validator: checkidCard,
            trigger: ['blur']
          }
        ],
        gradeId: [
          {
            required: true,
            message: '年级不能为空',
            trigger: ['blur', 'change']
          }
        ],
        classesId: [
          {
            required: true,
            message: '班级不能为空',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    classesList() {
      let _arr = []
      this.gradeList.forEach(k => {
        if (k.gradeId == this.student.gradeId) {
          _arr = k.classesList
          return _arr
        }
      })
      return _arr
    }
  },
  created() {
    this.type = localStorage.getItem('type')
    if (this.type == 8) {
      // 更改校验规则
      this.studentRules.rosterNo = [
        {
          required: true,
          message: '学员编号不能为空',
          trigger: ['blur']
        },
        {
          min: 6,
          message: '学员编号至少6位及以上',
          trigger: ['blur']
        }
      ]
    }
    // this.typeTime = setInterval(() => {
    //   this.type = localStorage.getItem('type')
    //   this.selectType()
    // }, 500);
    if (this.roleId == '-1003') {
      this.student.gradeId = Number(localStorage.getItem('gradeId'))
      this.student.classesId = Number(localStorage.getItem('classId'))
    }
    this.student.schoolId = localStorage.getItem('schoolIds')
  },
  methods: {
    // selectType(){
    //   if (this.type !== null) {
    //     clearInterval(this.typeTime)
    //   }
    // },

    studentAddFields() {
      this.flag = false
      this.$refs.student.resetFields()
    },
    parents() {
      this.parent.name = ''
      this.parent.mobile = ''
      this.parent.relation = ''
    },
    showDialog() {
      this.flag = true
      this.parents()
      this.dictCode()
    },
    hidedialogflag() {
      this.flag = false
      this.resetForm('student')
      // this.resetForm('parent')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    changeclassesList() {
      this.student.classesId = ''
    },
    // 生日框失去焦点
    blurIdCard() {
      const str = this.student.idCard
      const y = str.slice(6, 10)
      const m = str.slice(10, 12)
      const d = str.slice(12, 14)
      this.student.birth = y + '-' + m + '-' + d
    },
    // 添加学生Api
    ApiSaveStudent() {
      let data = {
        classesId: this.student.classesId,
        gradeId: this.student.gradeId,
        student: { ...this.student },
        parent: {
          ...this.parent,
          schoolId: localStorage.getItem('schoolIds')
        }
      }
      if (
        data.parent.name == '' &&
        data.parent.mobile == '' &&
        data.parent.relation == ''
      ) {
        delete data.parent
      }
      saveStudent({ ...data }).then(res => {
        if (res.data.code !== '0') {
          return false
        }
        this.hidedialogflag()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('updateList')
        this.resetForm('parent')
        this.$refs.student.resetFields()
        // this.ApiStudentListPag();
      })
    },

    // 字典  查询政治面貌
    async dictCode() {
      const { data: res } = await dictCode({
        code: 'political_type'
      })
      this.politicsList = res.data
    },
    // 添加确定按钮
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.parent.name || this.parent.mobile || this.parent.relation) {
            // if (
            //   this.parent.name !== '' &&
            //   this.parent.mobile !== '' &&
            //   this.parent.relation !== ''
            // ) {
            //   this.$message.error('其他家长项也是必填的哦')
            //   return false
            // }
            if (!/^1[0-9]{10}$/.test(this.parent.mobile)) {
              this.$message.error('请填写正确的家长手机号哦！')
              return false
            }
            if (this.parent.name == '') {
              this.$message.error('家长姓名是必填的哦！')
              return false
            } else if (this.parent.mobile == '') {
              this.$message.error('家长手机号是必填的哦！')
              return false
            } else if (this.parent.relation == '') {
              this.$message.error('关系是必选的哦！')
              return false
            }
          }
          this.ApiSaveStudent()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.AddStudentCom .el-form-item {
  margin: 20px 0;
}
.AddStudentCom .el-input__inner {
  width: 100%;
}

.el__dialog .el-dialog {
  max-height: 600px;
  overflow: auto;
  margin: 5vh auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/components/addStudent.vue